import { ReactComponent as Dino01 } from '../icons/dinosaurs/dino-01.svg';
import { ReactComponent as Dino02 } from '../icons/dinosaurs/dino-02.svg';
import { ReactComponent as Dino03 } from '../icons/dinosaurs/dino-03.svg';
import { ReactComponent as Dino04 } from '../icons/dinosaurs/dino-04.svg';
import { ReactComponent as Dino05 } from '../icons/dinosaurs/dino-05.svg';
import { ReactComponent as Dino06 } from '../icons/dinosaurs/dino-06.svg';
import { ReactComponent as Dino07 } from '../icons/dinosaurs/dino-07.svg';
import { ReactComponent as Dino08 } from '../icons/dinosaurs/dino-08.svg';
import { ReactComponent as Dino09 } from '../icons/dinosaurs/dino-09.svg';
import { ReactComponent as Dino10 } from '../icons/dinosaurs/dino-10.svg';
import { ReactComponent as Dino11 } from '../icons/dinosaurs/dino-11.svg';
import { ReactComponent as Dino12 } from '../icons/dinosaurs/dino-12.svg';
import { ReactComponent as Dino13 } from '../icons/dinosaurs/dino-13.svg';
import { ReactComponent as Dino14 } from '../icons/dinosaurs/dino-14.svg';
import { ReactComponent as Dino15 } from '../icons/dinosaurs/dino-15.svg';

const dinos = {
  1: { id: 1, Component: Dino01 },
  2: { id: 2, Component: Dino02 },
  3: { id: 3, Component: Dino03 },
  4: { id: 4, Component: Dino04 },
  5: { id: 5, Component: Dino05 },
  6: { id: 6, Component: Dino06 },
  7: { id: 7, Component: Dino07 },
  8: { id: 8, Component: Dino08 },
  9: { id: 9, Component: Dino09 },
  10: { id: 10, Component: Dino10 },
  11: { id: 11, Component: Dino11, skull: true },
  12: { id: 12, Component: Dino12, skull: true },
  13: { id: 13, Component: Dino13, skull: true },
  14: { id: 14, Component: Dino14, skull: true },
  15: { id: 15, Component: Dino15, skull: true },
};

export default dinos;
